import React, { useState } from "react";
import "./Feedback.scss";
import ReactStars from "react-rating-stars-component";

const Feedback = ({ orderId, onClose, setIsFeedbackSent }) => {
  const [feedback, setFeedback] = useState("");
  const [serviceFeedback, setServiceFeedback] = useState(0);
  const [foodFeedback, setFoodFeedback] = useState(0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Send feedback to the backend
    onClose();
  };

  return (
    <div className="feedback">
      <div className="popup-content">
        <button className="close-button" onClick={() => onClose()}>
          &#x2715;
        </button>
        <div className="title">
          <p>Оцени поръчката</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="input">
            <label htmlFor="">Как оценявате нашето обслужаване?</label>
            <ReactStars
              count={5}
              onChange={setServiceFeedback}
              size={30}
              activeColor="#FEAC7A"
              color="#EAEAEA"
              isHalf={true}
            />
          </div>
          <div className="input">
            <label htmlFor="">Как оценявате качеството на храната?</label>
            <ReactStars
              count={5}
              onChange={setFoodFeedback}
              size={30}
              color="#EAEAEA"
              activeColor="#FEAC7A"
              isHalf={true}
            />
          </div>
          <div className="input">
            <input
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder="Допълнителен коментар"
            />
          </div>
          <div className="button">
            <button type="submit">Изпрати</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Feedback;
